'use strict';

// --------------------------------------------------------------------
// Imports
// --------------------------------------------------------------------

require('./grammarDeferredInit');
require('./semanticsDeferredInit');
